import PropTypes from 'prop-types';
import styles from './credit-rating-chart.module.scss';
import { creditRatingModels } from '../../../../models/screener';
import { CREDIT_RATING_MODELS } from '../../../../shared/screener-constants';

import { augmentClassName } from '../../../../utils/GlobalCssProxy';

const className = augmentClassName(styles);

const CreditRatingChart = () => {
  const rating = creditRatingModels();

  return (
    <div {...className('credit-rating-chart')}>
      <span {...className('header')}>
        <span {...className('product-type')}>Fixed Annuity</span> &nbsp;- Credit Ratings
      </span>
      <BarRange rating={rating[CREDIT_RATING_MODELS.SP]} />
      <BarRange rating={rating[CREDIT_RATING_MODELS.MOODY]} />
      <BarRange rating={rating[CREDIT_RATING_MODELS.AMBEST]} />
      <BarRange rating={rating[CREDIT_RATING_MODELS.FITCH]} />
    </div>
  );
};

const BarRange = ({ rating }) => {
  return (
    <div {...className('bar-container')}>
      <div {...className('title')}>
        {rating.heading}
        <span {...className('ml-3', 'note')}>{rating.asOfDate}</span>
      </div>
      {rating.bars.map((el, index) => (
        <div
          data-key={`${rating.heading || ''}-${el}-${index}`}
          key={`${rating.heading || ''}-${el}-${index}`}
          {...className('rating-bar', el && 'active')}
        >
          {el ? rating.rating : ''}
        </div>
      ))}
      <div {...className('rating-bar-label')}>
        <span>Higher Credit Risk</span>
        <span>Lower Credit Risk</span>
      </div>
    </div>
  );
};

BarRange.propTypes = {
  rating: PropTypes.object
};

export default CreditRatingChart;
